module.exports = __webpack_public_path__ + "3e3286dc6645eb962d55199dc889418a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/27.jpg
// module id = 1354
// module chunks = 47